import type { RouteObject } from "react-router";
import { Navigate } from "react-router";
import { FEATURE } from "@/config/features";
import { Component } from "./utils";

export function getFrontendDashboardRoutes(): RouteObject[] {
	const frontendDashboardRoutes: RouteObject[] = [
		{ path: "workbench", element: Component("/pages/dashboard/workbench") },
		{ path: "analysis", element: Component("/pages/dashboard/analysis") },
		{ path: "callout-search", element: Component("/pages/callout-search") },
		{ path: "phonebook", element: Component("/pages/phonebook") },
		{ path: "customers", element: Component("/pages/customers") },
		// FEJLESZTÉS ALATT (ügyfélportál) — élesen a kapu zárva, így a cím
		// beírásával sem érhető el. Lásd config/features.ts.
		...(FEATURE.customerPortal
			? [
					{ path: "customer-change-requests", element: Component("/pages/customer-change-requests") },
					{ path: "portal-login-logs", element: Component("/pages/portal-login-logs") },
				]
			: []),
		// FEJLESZTÉS ALATT (sablon-szerkesztő) — élesen a kapu zárva, így a cím
		// beírásával sem érhető el. Lásd config/features.ts.
		...(FEATURE.contractTemplates
			? [
					{ path: "contract-templates", element: Component("/pages/contract-templates") },
					{ path: "contract-templates/:id", element: Component("/pages/contract-templates/edit") },
				]
			: []),
		{ path: "vehicles", element: Component("/pages/vehicles") },
		{ path: "projects", element: Component("/pages/projects") },
		{ path: "task-statuses", element: Component("/pages/task-statuses") },
		{ path: "tasks", element: Component("/pages/tasks") },
		{ path: "tasks/project/:projectId", element: Component("/pages/tasks/project") },
		{ path: "vehicle-notifications", element: Component("/pages/vehicle-notifications") },
		{ path: "vehicle-notification-categories", element: Component("/pages/vehicle-notification-categories") },
		{ path: "service-areas", element: Component("/pages/service-areas") },
		{ path: "partners", element: Component("/pages/partners") },
		{ path: "partners/create", element: Component("/pages/partners/create") },
		{ path: "partners/edit/:id", element: Component("/pages/partners/edit") },
		{ path: "partners/:id", element: Component("/pages/partners/detail") },
		{ path: "contracts", element: Component("/pages/contracts") },
		{ path: "contracts/create", element: Component("/pages/contracts/create") },
		{ path: "extra-services", element: Component("/pages/extra-services") },
		{ path: "contracts/:id", element: Component("/pages/contracts/detail") },
		{ path: "contracts/edit/:id", element: Component("/pages/contracts/edit") },
		{ path: "tavfelugyelet-elesites", element: Component("/pages/tavfelugyelet-elesites") },
		{ path: "tavfelugyelet-elesites/:id/edit", element: Component("/pages/tavfelugyelet-elesites/edit") },
		{ path: "tavfelugyelet-elesites/:id", element: Component("/pages/tavfelugyelet-elesites/detail") },
		{ path: "complaints", element: Component("/pages/complaints") },
		{ path: "complaints/map", element: Component("/pages/complaints/map") },
		{ path: "gsm-modules", element: Component("/pages/gsm-modules") },
		{ path: "complaints/create", element: Component("/pages/complaints/create") },
		{ path: "complaints/edit/:id", element: Component("/pages/complaints/edit") },
		{ path: "complaints/view/:id", element: Component("/pages/complaints/view") },
		{ path: "delinquent-contracts", element: Component("/pages/delinquent-contracts") },
		{ path: "delinquent-contracts/:id", element: Component("/pages/delinquent-contracts/detail") },
		{
			path: "invoices",
			children: [
				{ index: true, element: Component("/pages/invoices") },
				{ path: "approved", element: Component("/pages/invoices/approved") },
				{ path: "paid", element: Component("/pages/invoices/paid") },
			],
		},
		{ path: "roles", element: Component("/pages/roles") },
		{ path: "users", element: Component("/pages/users") },
		{ path: "deliquent-payment-mail-addresses", element: Component("/pages/deliquent-payment-mail-addresses") },
		{ path: "employees", element: Component("/pages/employees") },
		{ path: "resellers", element: Component("/pages/resellers") },
		{ path: "commissions", element: Component("/pages/commissions") },
		{ path: "task-management", element: Component("/pages/task-management") },
		{ path: "task-management/:id", element: Component("/pages/task-management/detail") },
		{ path: "developer-bug-report", element: Component("/pages/developer-bug-report") },
		{ path: "km-dictation", element: Component("/pages/km-dictation") },
		{ path: "km-overdue", element: Component("/pages/km-overdue") },
		{ path: "email-logs", element: Component("/pages/email-logs") },
		{ path: "developer-issues", element: Component("/pages/developer-issues") },
		{ path: "backup-destinations", element: Component("/pages/backup-destinations") },
		{ path: "company-documents", element: Component("/pages/company-documents") },
		{ path: "daily-events", element: Component("/pages/daily-events") },
		{ path: "price-quotes", element: Component("/pages/price-quotes") },
		{ path: "work-sheets", element: Component("/pages/work-sheets") },
		{ path: "work-sheets/create", element: Component("/pages/work-sheets/create") },
		{ path: "work-sheets/edit/:id", element: Component("/pages/work-sheets/edit") },
		{ path: "work-sheets/view/:id", element: Component("/pages/work-sheets/view") },
		{ path: "work-sheets/sign/:id", element: Component("/pages/work-sheets/sign") },
		// FEJLESZTÉS ALATT (adatbekérők) — élesen a kapu zárva, így a cím
		// beírásával sem érhető el. Lásd config/features.ts.
		...(FEATURE.dataRequests
			? [
					{ path: "data-request-types", element: Component("/pages/data-request-types") },
					{ path: "data-requests", element: Component("/pages/data-requests") },
					{ path: "data-requests/:id", element: Component("/pages/data-requests/view") },
				]
			: []),
		// FEJLESZTÉS ALATT (levelező) — élesen a kapu zárva, így a cím
		// beírásával sem érhető el. Lásd config/features.ts.
		...(FEATURE.mailClient ? [{ path: "mail", element: Component("/pages/mail") }] : []),
		// Fejlesztés alatt: a /data-requests/outbox végpont élesen nem létezik.
		// Lásd config/features.ts — alapból KI, hogy a cím beírásával se
		// lehessen elérni egy működésképtelen oldalt. A statikus szakasz
		// szándékosan a dinamikus :id ELŐTT van.
		...(FEATURE.dataRequestOutbox
			? [{ path: "data-requests/outbox", element: Component("/pages/data-requests/outbox") }]
			: []),
		{ path: "products", element: Component("/pages/products") },
		{ path: "maintenance-overview", element: Component("/pages/maintenance-overview") },
		{ path: "survey-sheets", element: Component("/pages/survey-sheets") },
		{ path: "survey-sheets/create", element: Component("/pages/survey-sheets/create") },
		{ path: "survey-sheets/edit/:id", element: Component("/pages/survey-sheets/edit") },
		{ path: "survey-sheets/view/:id", element: Component("/pages/survey-sheets/view") },
		{ path: "inventory", element: Component("/pages/inventory") },
		{ path: "inventory/receipt", element: Component("/pages/inventory/receipt") },
		{ path: "inventory/issue", element: Component("/pages/inventory/issue") },
		{ path: "inventory/technician-stocks", element: Component("/pages/inventory/technician-stocks") },
		{ path: "inventory/defective", element: Component("/pages/inventory/defective") },
		{ path: "inventory/repaired", element: Component("/pages/inventory/repaired") },
		{ path: "inventory/scrapped", element: Component("/pages/inventory/scrapped") },
		{ path: "inventory/logs", element: Component("/pages/inventory/logs") },
		{ path: "inventory/categories", element: Component("/pages/inventory/categories") },
		{ path: "inventory/suppliers", element: Component("/pages/inventory/suppliers") },
		{ path: "inventory/locations", element: Component("/pages/inventory/locations") },
		{ path: "inventory/technicians", element: Component("/pages/inventory/technicians") },
		{ path: "inventory/stocktake", element: Component("/pages/inventory/stocktake") },
		{ path: "inventory/reports", element: Component("/pages/inventory/reports") },
		{
			path: "components",
			children: [
				{ index: true, element: <Navigate to="animate" replace /> },
				{ path: "animate", element: Component("/pages/components/animate") },
				{ path: "scroll", element: Component("/pages/components/scroll") },
				{ path: "multi-language", element: Component("/pages/components/multi-language") },
				{ path: "icon", element: Component("/pages/components/icon") },
				{ path: "upload", element: Component("/pages/components/upload") },
				{ path: "chart", element: Component("/pages/components/chart") },
				{ path: "toast", element: Component("/pages/components/toast") },
			],
		},
		{
			path: "functions",
			children: [
				{ index: true, element: <Navigate to="clipboard" replace /> },
				{ path: "clipboard", element: Component("/pages/functions/clipboard") },
				{ path: "token_expired", element: Component("/pages/functions/token-expired") },
			],
		},
		{
			path: "management",
			children: [
				{ index: true, element: <Navigate to="user" replace /> },
				{
					path: "user",
					children: [
						{ index: true, element: <Navigate to="profile" replace /> },
						{ path: "profile", element: Component("/pages/management/user/profile") },
						{ path: "account", element: Component("/pages/management/user/account") },
					],
				},
				{
					path: "system",
					children: [
						{ index: true, element: <Navigate to="permission" replace /> },
						{ path: "permission", element: Component("/pages/management/system/permission") },
						{ path: "role", element: Component("/pages/management/system/role") },
						{ path: "user", element: Component("/pages/management/system/user") },
						{ path: "user/:id", element: Component("/pages/management/system/user/detail") },
					],
				},
			],
		},
		{
			path: "error",
			children: [
				{ index: true, element: <Navigate to="403" replace /> },
				{ path: "403", element: Component("/pages/sys/error/Page403") },
				{ path: "404", element: Component("/pages/sys/error/Page404") },
				{ path: "500", element: Component("/pages/sys/error/Page500") },
			],
		},
		{
			path: "menu_level",
			children: [
				{ index: true, element: <Navigate to="1a" replace /> },
				{ path: "1a", element: Component("/pages/menu-level/menu-level-1a") },
				{
					path: "1b",
					children: [
						{ index: true, element: <Navigate to="2a" replace /> },
						{ path: "2a", element: Component("/pages/menu-level/menu-level-1b/menu-level-2a") },
						{
							path: "2b",
							children: [
								{ index: true, element: <Navigate to="3a" replace /> },
								{ path: "3a", element: Component("/pages/menu-level/menu-level-1b/menu-level-2b/menu-level-3a") },
								{ path: "3b", element: Component("/pages/menu-level/menu-level-1b/menu-level-2b/menu-level-3b") },
							],
						},
					],
				},
			],
		},
		{
			path: "link",
			children: [
				{ index: true, element: <Navigate to="iframe" replace /> },
				{ path: "iframe", element: Component("/pages/sys/others/link/iframe", { src: "https://ant.design/index-cn" }) },
				{
					path: "external-link",
					element: Component("/pages/sys/others/link/external-link", { src: "https://ant.design/index-cn" }),
				},
			],
		},
		{
			path: "permission",
			children: [
				{ index: true, element: Component("/pages/sys/others/permission") },
				{ path: "page-test", element: Component("/pages/sys/others/permission/page-test") },
			],
		},
		{ path: "calendar", element: Component("/pages/sys/others/calendar") },
		{ path: "kanban", element: Component("/pages/sys/others/kanban") },
		{ path: "blank", element: Component("/pages/sys/others/blank") },
	];
	return frontendDashboardRoutes;
}
